import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg width="1em" height="1em" viewBox="0 0 20 20" focusable="false" fill="currentColor" aria-hidden="true"><g fillRule="nonzero" fill="none"><path d="M19.45 2.22h-8.9v15.539h8.9c.317 0 .55-.254.55-.55V2.791c0-.317-.233-.571-.55-.571Z" fill="#4CAF50" /><path d="M14.45 5.01h3.897v1.67H14.45V5.01Zm0 5.54h3.897v1.67H14.45v-1.67Zm0 2.77h3.897v1.67H14.45v-1.67Zm0-5.54h3.897v1.67H14.45V7.78Zm-3.9-2.77h2.776v1.67h-2.775V5.01Zm0 5.54h2.776v1.67h-2.775v-1.67Zm0 2.77h2.776v1.67h-2.775v-1.67Zm0-5.54h2.776v1.67h-2.775V7.78Z" fill="#FFF" /><path fill="#2E7D32" d="M11.674 20 0 17.78V2.22L11.674 0z" /><path d="m7.267 13.805-1.314-2.473a1.869 1.869 0 0 1-.148-.507h-.042c-.021.126-.085.296-.17.528L4.28 13.805H2.225L4.66 10 2.436 6.195h2.098l1.102 2.283c.084.19.17.401.233.634h.02c.043-.148.128-.36.234-.655l1.186-2.262h1.907L6.95 9.958l2.352 3.847H7.267Z" fill="#FFF" /></g></svg>

const Xls = React.forwardRef((props, ref) => {
  return (
    <IconBase name="xls" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Xls.displayName = 'IconXls'

export default Xls
